// constants.js
export const REDIRECT_FE_URLS = {
    dashboard: '/dashboard',
    complete_onboarding: '/auth/complete-onboarding',
    call_insights: '/assets/insights',
    account_status: '/auth/account-status',
    app_download: '/app-download'
};